import React from 'react';
import {AdvancedMarker, PinElement, Polyline} from "react-google-map-wrapper";
import {Itinerary} from "../interface/Itinerary";

type Props = {
    itinerary: Itinerary
}

const MapItinerary: React.FC<Props> = (props) => {
    return (
        <>
            <Polyline
                path={props.itinerary.points}
                strokeColor="#76bd4c"
                strokeOpacity={1.0}
                strokeWeight={4}
                geodesic
            />

            {
                props.itinerary.pointsOfInterest.length ?
                    props.itinerary.pointsOfInterest.map((pointOfInterest, index) => (
                        <AdvancedMarker lat={pointOfInterest.geopoint.lat} lng={pointOfInterest.geopoint.lng}
                                        key={index}>
                            <PinElement glyphColor={'white'} background={'blue'} borderColor={'blue'}
                                        scale={0.8}/>
                        </AdvancedMarker>
                    ))
                    : <></>
            }
        </>
    )
}

export default MapItinerary
